import SystemCheckOutlineIcon from '@kcd/design-system/dist/icons/ic__system__check__outline.svg';
import SystemDownloadOutlineIcon from '@kcd/design-system/dist/icons/ic__system__download__outline.svg';

import CouponEmptyIcon from './ic__coupon-empty.svg';
import CouponRadioIcon from './ic__coupon-radio.svg';

export {
  CouponEmptyIcon,
  CouponRadioIcon,
  SystemCheckOutlineIcon,
  SystemDownloadOutlineIcon,
};
